import { useState } from 'react';

import { VedomItem, BusMapData } from '../types/app.types';

export const useVedomState = () => {
  const [vedomData, setVedomData] = useState<VedomItem[] | null>(null);
  const [busMapData, setBusMapData] = useState<BusMapData | null>(null);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [selectedRoute, setSelectedRoute] = useState<VedomItem | null>(null);

  const clearError = () => setError(null);

  const clearVedomData = () => {
    setVedomData(null);
    setBusMapData(null);
    setError(null);
  };

  const clearBusMapData = () => {
    setBusMapData(null);
    setSelectedRoute(null);
    setModalLoading(false);
    setError(null);
  };

  return {
    vedomData,
    setVedomData,
    busMapData,
    setBusMapData,
    loading,
    setLoading,
    modalLoading,
    setModalLoading,
    error,
    setError,
    selectedRoute,
    setSelectedRoute,
    clearError,
    clearVedomData,
    clearBusMapData
  };
};